module.exports = __webpack_public_path__ + "img/dhs2.c764cc1a.jpg";